import { Action } from 'redux';

export const ENABLE_LOADING = 'ENABLE_LOADING';
export const DISABLE_LOADING = 'DISABLE_LOADING';

export type EnableLoading = Action<typeof ENABLE_LOADING>;
export type DisableLoading = Action<typeof DISABLE_LOADING>;

export type ListLoadingAction = EnableLoading | DisableLoading;
